import { Link, useLocation, Navigate } from "react-router-dom";
import "./index.scss";

const formatDate = (isoString) => {
  if (!isoString) return "";
  try {
    return new Date(isoString).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "";
  }
};

const Success = () => {
  const { state } = useLocation();

  // Someone landed here directly (refresh / bookmark) with no registration
  // data — send them back to start a new one instead of showing an empty page.
  if (!state) {
    return <Navigate to="/" replace />;
  }

  const {
    customerName,
    email,
    mobileNumber,
    city,
    state: stateName,
    pinCode,
    productLabel,
    warrantySummary,
    invoiceFileName,
    hasProductVideo,
    registeredAt,
  } = state;

  const referenceId = `NO-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1>Warranty registered successfully!</h1>

        <div className="details">
          <div className="details__row">
            <span>Customer</span>
            <span>{customerName || "—"}</span>
          </div>
          <div className="details__row">
            <span>Mobile</span>
            <span>{mobileNumber || "—"}</span>
          </div>
          <div className="details__row">
            <span>Location</span>
            <span>
              {[city, stateName, pinCode].filter(Boolean).join(", ") || "—"}
            </span>
          </div>
          <div className="details__row">
            <span>Product</span>
            <span>{productLabel || "—"}</span>
          </div>
          <div className="details__row">
            <span>Warranty Type</span>
            <span className="details__accent">{warrantySummary || "—"}</span>
          </div>
          {/* <div className="details__row">
            <span>Invoice</span>
            <span>{invoiceFileName || "—"}</span>
          </div> */}
          {/* <div className="details__row">
            <span>Product Video</span>
            <span>{hasProductVideo ? "Attached" : "Not provided"}</span>
          </div> */}
          <div className="details__row">
            <span>Registered On</span>
            <span>{formatDate(registeredAt)}</span>
          </div>
        </div>

        <Link to="/" className="success-btn">
          Register Another Appliance
        </Link>
      </div>
    </div>
  );
};

export default Success;
